import { Card, CardContent, Typography, Button, Box, Dialog, DialogContent } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useState } from 'react';
import { useSession } from '../context/SessionContext';

export default function WelcomePage() {
  const { session, updateStatus } = useSession();
  const [isInstructionsOpen, setIsInstructionsOpen] = useState(false);
  const instructionsVideoEmbedUrl = 'https://go.screenpal.com/player/cOQXbtnwG4Y';
  const courseLevel = session?.assessment_course_level?.trim() || 'Precalculus I';
  const assessmentDescription = session?.assessment_description?.trim();
  const questionCount = session?.questions_count ?? 22;

  const handleStart = async () => {
    await updateStatus('pre_survey');
  };

  const handleOpenInstructions = () => {
    setIsInstructionsOpen(true);
  };

  const handleCloseInstructions = () => {
    setIsInstructionsOpen(false);
  };

  return (
    <Card>
      <CardContent sx={{ p: 4 }}>
        <Box textAlign="center" mb={4}>
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            color="primary"
            sx={{ fontWeight: 600 }}
          >
            {`${courseLevel} Readiness Check`}
          </Typography>
          
          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            sx={{ lineHeight: 1.1 }}
          >
            <Box
              component="span"
              sx={{
                fontFamily: 'Georgia, serif',
                fontStyle: 'italic',
                fontWeight: 400,
                color: '#ffc400',
              }}
            >
              al
            </Box>
            <Box
              component="span"
              sx={{
                fontFamily: '"Gill Sans", "Gill Sans MT", Calibri, sans-serif',
                fontWeight: 700,
                color: '#0b4fae',
                letterSpacing: '0.04em',
              }}
            >
              MATHEMA
            </Box>{' '}
            <Box component="span" sx={{ color: 'text.secondary' }}>
              pilot
            </Box>
          </Typography>
          
        </Box>

        <Box sx={{ maxWidth: 600, mx: 'auto', mb: 4 }}>
          <Typography variant="body1" paragraph>
            {assessmentDescription || `This assessment is designed to help you understand your starting point for ${courseLevel}. It highlights what you already know and which topics may benefit from a bit of review, so you can move into the course with confidence.`}
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>What to expect</strong>
          </Typography>
          
          <Box component="ul" sx={{ pl: 3, mb: 3 }}>
            <li>
              <Typography variant="body1">
                {`${questionCount} questions covering key prerequisite skills`}
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                About 30 to 45 minutes to complete
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                Personalized feedback with learning resource recommendations to help you focus on what matters most
              </Typography>
            </li>
          </Box>

          <Typography variant="body1" paragraph>
          Some questions may feel straightforward. Others may feel challenging. That is completely normal and part of the process.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>Important</strong>
          </Typography>
          
          <Typography variant="body1" paragraph>
            This assessment is not graded and does not affect your course grade. There is no pass or fail. 
            The goal is understanding, not evaluation.
           </Typography>

          <Typography variant="body1" paragraph>
            {`Your results will help you decide where to focus your time and how to best prepare for success in ${courseLevel}.`}
           </Typography>
        </Box>

        <Box textAlign="center">
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
            <Button
              variant="outlined"
              size="large"
              onClick={handleOpenInstructions}
              sx={{ px: 3, py: 1.5 }}
              aria-label="Open instructions video"
            >
              Watch Instructions Video
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={handleStart}
              endIcon={<PlayArrowIcon />}
              sx={{ px: 6, py: 1.5 }}
              aria-label="Start the assessment"
            >
              Start Readiness Check
            </Button>
          </Box>
        </Box>

        <Dialog
          open={isInstructionsOpen}
          onClose={handleCloseInstructions}
          maxWidth="md"
          fullWidth
        >
          <DialogContent sx={{ p: 0 }}>
            <Box sx={{ position: 'relative', width: '100%', pt: '56.25%' }}>
              <Box
                component="iframe"
                src={instructionsVideoEmbedUrl}
                title="alMATHEMA readiness check instructions video"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 0,
                }}
              />
            </Box>
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
              <Button onClick={handleCloseInstructions}>Close</Button>
            </Box>
          </DialogContent>
        </Dialog>
      </CardContent>
    </Card>
  );
}
